
export const projects = [
    {
        name: 'Testassessify',
        description: `Advanced employee assessment platform which efficiently screens high-volume applications, accurately ranks top talent, and reduces  time-to-hire.`,
        // githubLink : 'https://github.com/ahmedsaniadamu/ammistore' ,
        liveSite: 'https://ammistore.000webhostapp.com',
        image: 'assets/testassessify.PNG'
    },
    {
        name: 'Maltina Nourishment Tour',
        description: 'Platfform that brings science to life in schools across Nigeria, transforming classrooms into vibrant hubs of discovery, energizing lunchboxes, and reigniting a love for learning.',
        // githubLink: 'https://www.github.com/admin-strap-ui',
        liveSite: 'https://maltina.nbplc.com/',
        image: 'assets/maltina.PNG'
    },
    {
        name: '2Zero Invest',
        description: 'A professional investment management platform that helps customers invest on their terms and see their wealth grow.',
        // githubLink: 'https://www.github.com/admin-strap-ui',
        liveSite: 'https://2zeroinvest.com/',
        image: 'assets/2zero.PNG'
    },
    {
        name: 'Fanndrop',
        description: `The platform that helps artists share their earliest work and gives fans a chance to support them from the start.`,
        // githubLink: 'https://www.github.com/admin-strap-ui',
        liveSite: 'https://fanndrop.com/',
        image: 'assets/fanndrop.PNG'
    },
    {
        name: "Life Nwa Boi Experience",
        description: `The Life Nwa Boi Experience is an initiative by Life Lager, rooted in the rich Igbo tradition of entrepreneurship and inspired by the revered Nwa Boi apprenticeship system. This platform is designed to transform hustlers into thriving business owners by providing mentorship, seed capital, and brand support.`,
        liveSite: 'https://lifenwaboi.nbplc.com/',
        image: 'assets/life.PNG'
    },
    {
        name: 'Service School House',
        description: 'An e-learning platform to turn your customer service team into a competitive advantage with the relevant knowledge, tools and techniques through practical and interactive training courses',
        // githubLink: 'https://www.github.com/admin-strap-ui',
        liveSite: 'https://serviceschoolhouse.com/',
        image: 'assets/ssh.PNG'
    },
    {
        name: 'ACCTCI Website',
        description: 'Organisational website for (African Caribbean Chamber of Trade Commerce & Industry)',
        // githubLink: 'https://www.github.com/admin-strap-ui',
        liveSite: 'https://acctci.org/',
        image: 'assets/acctci.PNG'
    },
    {
        name: 'Konga Landing Page',
        description: 'A legacy project for my earliest frontend carrier back in 2022, a pixel-perfect clone of Konga landing page, showcasing my attention to detail and commitment to excellence in frontend development.',
        githubLink: 'https://www.github.com/ahmedsaniadamu/konga-clone',
        liveSite: 'https://konga-landingpage-clone.netlify.app',
        image: 'assets/konga-n.PNG'
    },
    {
        name: 'Alibaba Landing page',
        description: 'A legacy project for my earliest frontend carrier back in 2022, a functional Alibaba clone with responsive design and interactive UI/UX',
        githubLink: 'https://www.github.com/ahmedsaniadamu/alibaba-clone',
        liveSite: 'https://alibabahomepageclone.netlify.app',
        image: 'assets/alibaba.PNG'
    },
]